<template>
  <div class="management-page-outer-container">
    <router-view />
    <reservations-list
      v-if="$route.name === 'asset-reservations'"
      :workspace-uuid="workspaceUUID"
      :search="search"
      @update-workspace-uuid="workspaceUUID = $event"
      @update-search="search = $event"
    />
  </div>
</template>

<script>
import ReservationsList from "@/components/AssetReservationManagement/Data/ReservationsList";

export default {
  name: "AssetReservationsManagementMainPage",

  components: {
    ReservationsList
  },

  data() {
    return {
      /**
       * Save the value of the uuid the selected workspace
       */
      workspaceUUID: null,
      /**
       * Save the value of the last search
       */
      search: ""
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Data/AssetReservations.vue